// NOTICE: KAPTION-INTEGRATION
import ApiClient from './ApiClient';

class AiStudio extends ApiClient {
  constructor() {
    super('ai_studio', { accountScoped: true });
  }

  fetchToken(params = {}) {
    return this.show('token', params);
  }
}

export default new AiStudio();
